
import { pipelineContext, runPipeline } from './pipelineRunner.js'
import { canApproveClaimPipeline } from './canApproveClaimPipeline.js'

let runCanApproveClaimPipeline = (selectedClaim) => {

    let context = pipelineContext(selectedClaim)


    return runPipeline(canApproveClaimPipeline, context)
}

export { runCanApproveClaimPipeline }